import { constants } from '../constants';
import { getProcessEnvs, getWindowSession } from './helper';

/**
 * Checks whether login is disabled for the current locale.
 *
 * This function determines if login functionality should be disabled based on the user's locale.
 * It first retrieves the list of disabled locales from the environment variable
 * `NEXT_PUBLIC_LIST_OF_LOCALE_LOGIN_IS_DISABLED`. If the environment variable is not set or is invalid,
 * it falls back to the constant `constants.LIST_OF_LOCALE_LOGIN_IS_DISABLED`.
 *
 * The function then checks the user's locale and its variation (with underscores replaced by hyphens)
 * against the list of disabled locales.
 *
 * @returns {boolean} - Returns `true` if login is disabled for the current locale, otherwise `false`.
 */
export function isLoginDisabledBasedOnLocale(): boolean {
  const { NEXT_PUBLIC_LIST_OF_LOCALE_LOGIN_IS_DISABLED } = getProcessEnvs();
  const sessionData = getWindowSession();
  const locales: string[] = [sessionData?.locale, sessionData?.locale?.replace('_', '-')].filter(Boolean);

  let listOfLocaleLoginIsDisabled: string[];

  try {
    // Attempt to parse the environment variable as JSON
    listOfLocaleLoginIsDisabled = NEXT_PUBLIC_LIST_OF_LOCALE_LOGIN_IS_DISABLED
      ? JSON.parse(NEXT_PUBLIC_LIST_OF_LOCALE_LOGIN_IS_DISABLED)
      : constants.LIST_OF_LOCALE_LOGIN_IS_DISABLED;
  } catch (error) {
    // Fallback to the constant if JSON.parse fails
    listOfLocaleLoginIsDisabled = constants.LIST_OF_LOCALE_LOGIN_IS_DISABLED;
  }

  // Check if any of the user's locales are in the list of disabled locales
  return locales.some(locale => listOfLocaleLoginIsDisabled.includes(locale));
}
